import { classNames } from "Utils/utils";
import { FiCheckCircle } from "react-icons/fi";

export const StepProgressIndicator = ({
  steps,
  currentStep,
  onStepClick,
  allowAllSteps = false,
}) => {
  const handleStepClick = (targetIndex) => {
    if (onStepClick) {
      onStepClick(targetIndex);
    }
  };

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between relative">
        {/* Background Timeline */}
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200 -z-10" />
        {/* Progress Timeline */}
        <div
          className="absolute top-5 left-0 h-0.5 bg-blue-600 -z-10 transition-all duration-500"
          style={{
            width: `${(currentStep / (steps.length - 1)) * 100}%`,
          }}
        />

        {steps.map((step, index) => {
          const StepIcon = step.icon;
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isClickable =
            allowAllSteps || index <= currentStep || index === 0;

          return (
            <div
              key={step.id}
              className="flex flex-col items-center relative z-10 flex-1"
            >
              <button
                type="button"
                onClick={() => handleStepClick(index)}
                disabled={!isClickable}
                className={classNames(
                  "flex flex-col items-center relative z-10 transition-all w-full",
                  isClickable
                    ? "cursor-pointer hover:scale-105"
                    : "cursor-not-allowed opacity-50"
                )}
              >
                <div
                  className={classNames(
                    "w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300",
                    isCompleted
                      ? "bg-green-500 text-white"
                      : isCurrent
                      ? "bg-blue-600 text-white ring-4 ring-blue-100"
                      : "bg-gray-200 text-gray-500"
                  )}
                >
                  {isCompleted ? (
                    <FiCheckCircle className="w-5 h-5" />
                  ) : (
                    <StepIcon className="w-5 h-5" />
                  )}
                </div>
                <span
                  className={classNames(
                    "text-xs mt-1.5 font-medium text-center max-w-[80px]",
                    isCurrent
                      ? "text-blue-600"
                      : isCompleted
                      ? "text-green-600"
                      : "text-gray-500"
                  )}
                >
                  {step.label}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
